import {useDispatch,useSelector} from 'react-redux'
import {useCart} from '../hooks'
import {
	selectMerchandiseById,
	updateItemCartQty,
	setShowCheckout
} from '../slice'
import {selectAcceptedCurrency} from '../../settings/settingsSlice'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

const CartItem = ({itemId,qty})=>{
	const dispatch = useDispatch()
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const item = useSelector(state=>selectMerchandiseById(state,itemId))
	const handleUpdateItemQty = e => {
		const val = Math.max(1,parseInt(e.target.value))
		dispatch(updateItemCartQty({id:itemId,qty:val}))
	}
	const handleRemoveItem = () => {
		dispatch(updateItemCartQty({id:itemId,qty:0}))
	}
	return (
		<div className="d-flex mb-2" style={{borderBottom:'1px solid #eee'}}>
			<div className="d-flex">
				<div>
					<div>{item.title}</div>
					<div>
						<small className="text-muted">
							{item.description}
						</small>
					</div>
				</div>
			</div>
			<div className="ml-auto text-right">
				<div className="d-flex align-items-center">
					<span>
						{String.fromCharCode(acceptedCurrency.char_code)}{parseFloat((item.unit_amount/100).toFixed(2))} ({acceptedCurrency.ISO})
					</span>
					<Form.Control 
						onChange={handleUpdateItemQty}
						type="number" 
						value={qty} 
						size="sm" 
						style={{width:'60px',marginLeft:'8px',textAlign:'right'}}
					/>
				</div>
				<Button onClick={handleRemoveItem} variant="link" className="text-danger" size="sm">
					Remove
				</Button>
			</div>
		</div>
	)
}

const Cart = ()=>{
	const dispatch = useDispatch()
	const {hasItems,itemsQtyMap,total} = useCart()
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const handleCheckout = ()=>{
		dispatch(setShowCheckout(true))
	}
	return (
		<div>
			{
				!hasItems?
				<strong>You haven't added any items to your cart</strong>:
				<div>
					{Object.entries(itemsQtyMap).map(([itemId,qty])=><CartItem key={itemId} itemId={itemId} qty={qty}/>)}

					<div className="text-right">
						<strong className="mr-2">Total:</strong> 
						{String.fromCharCode(acceptedCurrency.char_code)}
						{total}  ({acceptedCurrency.ISO})
					</div>
					<div className="text-right my-3">
						<Button 
							onClick={handleCheckout}
							variant="outline-success"
							className="px-5"
						>
							Checkout
						</Button>
					</div>
				</div>
			}
		</div>
	)
}

export default Cart